export default function setUrlParam(name, value, resetCurrentPage = true) {
  const url = new URL(window.location.href)
  value ? url.searchParams.set(name, value) : url.searchParams.delete(name)

  if (resetCurrentPage) {
    url.searchParams.set('currentPage', 1)
  }

  window.history.replaceState({}, '', url)
}